module.exports = __webpack_public_path__ + "img/logo.0bfb7066.png";